import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { QueryKeys } from "@/queries/utils";
import {
  AdminJobCandidateDetails,
  AdminJobDetails,
} from "@/queries/admin/job-details";
import { AdminAddCandidateToJobFormSchema } from "@/components/forms/admin/job-candidate/candidate-status/schema";

export const useCreateCandidateStatus = (
  openingId: string,
  onSuccessCb?: () => void,
) => {
  const qc = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async (data: AdminAddCandidateToJobFormSchema) => {
      const token = await getAccessTokenSilently();

      const payload: Partial<AdminAddCandidateToJobFormSchema> = {
        ...data,
      };

      delete payload.candidate;

      return request<AdminJobCandidateDetails>({
        method: "POST",
        path: `/api/admin/job_opening/${openingId}/candidate/${data.candidate}`,
        token,
        body: JSON.stringify(payload),
      });
    },
    onSuccess: (data) => {
      // Fetch any existing data
      const prev = qc.getQueryData<AdminJobDetails>(
        QueryKeys.adminJobDetails(openingId),
      );

      // If there is existing data, add to it
      if (prev) {
        qc.setQueryData(QueryKeys.adminJobDetails(openingId), {
          ...prev,
          candidates: [...prev.candidates, data],
        });
      } else {
        // If the entry couldn't be found, invalidate and fetch new data
        void qc.invalidateQueries({
          queryKey: QueryKeys.adminJobDetails(openingId),
        });
      }

      onSuccessCb?.();
    },
  });

  return {
    createCandidateOpportunityStatus: mutate,
    isCreatingCandidateOpportunityStatus: isPending,
    creatingCandidateOpportunityStatusError: error,
  };
};
